import React, { useEffect, useState } from "react";
import {
  collection,
  getDocs,
  query,
  where,
  doc,
  updateDoc,
  orderBy
} from "firebase/firestore";

import { db } from "../firebase";
import Layout from "../components/Layout";

function MasterPendingOrders() {
  const [orders, setOrders] = useState([]);
  const [skuList, setSkuList] = useState([]);
  const [loading, setLoading] = useState(true);

  // =========================
  // LOAD SKU MASTER
  
  // =========================
  useEffect(() => {
    const loadSku = async () => {
      const q = query(
  collection(db, "skuMaster"),
  orderBy("sortorder", "asc")
);

const snap = await getDocs(q);
const arr = snap.docs.map((d) => d.data().sku);
setSkuList(arr);

    };
    loadSku();
  }, []);

  // =========================
  // LOAD PENDING ORDERS
  // =========================
  useEffect(() => {
    const loadOrders = async () => {
      const q = query(
        collection(db, "orders"),
        where("status", "==", "PENDING")
      );

      const snap = await getDocs(q);

      const arr = snap.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      setOrders(arr);
      setLoading(false);
    };

    loadOrders();
  }, []);

  // =========================
  // EDIT CELL
  // =========================
  const updateQty = (orderIndex, sku, value) => {
    const newOrders = [...orders];

    if (!newOrders[orderIndex].items) newOrders[orderIndex].items = {};
    newOrders[orderIndex].items[sku] = value;


    setOrders(newOrders);
  };

  // =========================
  // SAVE ALL
  // =========================
  const saveAll = async () => {
    for (const order of orders) {
      let totalQty = 0;

      Object.values(order.items || {}).forEach((q) => {
        totalQty += Number(q || 0);
      });

      const cleanedItems = {};

Object.keys(order.items || {}).forEach((k) => {
  cleanedItems[k] = Number(order.items[k] || 0);
});

await updateDoc(doc(db, "orders", order.id), {
  items: cleanedItems,
  totalQty,
});

    }

    alert("Saved successfully");
  };

  if (loading) return <p>Loading...</p>;

  // =========================
  // UI
  // =========================
  return (
    <Layout>
      <div style={{ padding: 20 }}>
        <h2>Master Pending Orders</h2>

        <button
          onClick={saveAll}
          style={{
            marginBottom: 15,
            padding: "10px 18px",
            background: "#198754",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            fontWeight: 600,
          }}
        >
          SAVE ALL
        </button>

        <div
  style={{
    overflow: "auto",
    maxHeight: "75vh",
    border: "1px solid #ddd"
  }}
>

          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
              fontSize: 14,
            }}
          >
           <thead>
  <tr>
    <th style={{ ...th, position: "sticky", top: 0, left: 0, zIndex: 3 }}>
      Party
    </th>

    {skuList.map((sku) => (
      <th
        key={sku}
        style={{
          ...th,
          position: "sticky",
          top: 0,
          zIndex: 2,
          background: "#f3f3f3"
        }}
      >
        {sku}
      </th>
    ))}

    <th
      style={{
        ...th,
        position: "sticky",
        top: 0,
        zIndex: 2
      }}
    >
      Total
    </th>
  </tr>
</thead>


            <tbody>
              {orders.map((order, i) => {
                let total = 0;

                return (
                  <tr key={order.id}>
                    <td
  style={{
    ...td,
    position: "sticky",
    left: 0,
    background: "#fff",
    zIndex: 1,
    fontWeight: 600
  }}
>
  {order.partyName}
</td>


                    {skuList.map((sku) => {
                      const val = order.items?.[sku] || "";

                      total += Number(val || 0);

                      return (
                        <td style={td} key={sku}>
                          
						  
						  <input
  value={val}
  onChange={(e) => updateQty(i, sku, e.target.value)}
  data-row={i}
  data-col={sku}
  onKeyDown={(e) => {
	  // BLOCK LETTERS — allow only numbers & decimal
const allowed =
  (e.key >= "0" && e.key <= "9") ||
  e.key === "." ||
  e.key === "Backspace" ||
  e.key === "Delete" ||
  e.key === "Tab" ||
  e.key === "Enter" ||
  e.key === "ArrowLeft" ||
  e.key === "ArrowRight" ||
  e.key === "ArrowUp" ||
  e.key === "ArrowDown";

if (!allowed) {
  e.preventDefault();
  return;
}

// prevent multiple decimals
if (e.key === "." && e.target.value.includes(".")) {
  e.preventDefault();
  return;
}

	  
	  
	  
    const row = i;
    const colIndex = skuList.indexOf(sku);

    let nextRow = row;
    let nextCol = colIndex;

    // ENTER ↓
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      nextRow = row + 1;
    }

    // SHIFT+ENTER ↑
    if (e.key === "Enter" && e.shiftKey) {
      e.preventDefault();
      nextRow = row - 1;
    }

    // ARROW DOWN
    if (e.key === "ArrowDown") {
      e.preventDefault();
      nextRow = row + 1;
    }

    // ARROW UP
    if (e.key === "ArrowUp") {
      e.preventDefault();
      nextRow = row - 1;
    }

    // ARROW RIGHT
    if (e.key === "ArrowRight") {
      e.preventDefault();
      nextCol = colIndex + 1;
    }

    // ARROW LEFT
    if (e.key === "ArrowLeft") {
      e.preventDefault();
      nextCol = colIndex - 1;
    }

    const nextSku = skuList[nextCol];

    const next = document.querySelector(
      `input[data-row='${nextRow}'][data-col='${nextSku}']`
    );

    if (next) next.focus();
  }}
  style={{
    width: 60,
    padding: 4,
    textAlign: "center",
  }}
/>

						  
						  
                        </td>
                      );
                    })}

                    <td style={td}>
                      <b>{total}</b>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}

const th = {
  border: "1px solid #ccc",
  padding: 6,
  background: "#f3f3f3",
};

const td = {
  border: "1px solid #ccc",
  padding: 4,
  textAlign: "center",
};

export default MasterPendingOrders;
